import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/auth.service';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const accessToken = this.authService.activeToken;
        // add authorization header with jwt token if available
        if (accessToken !== null) {
            if (accessToken) {
                request = request.clone({
                    setHeaders: {
                        Authorization: `${accessToken}`
                    }
                });
            }
        }

        return next.handle(request);
    }
}